import { VStack } from "@chakra-ui/react";
import { Bundle } from "../../../../types";
import { Stats } from "../../../../screens/reader/components/shared/Stats";
import { formatLargeNumber } from "../../../../utils/formatLargeNumber";
import { t } from "i18next";

interface BundleStatsProps {
  bundle: Bundle;
}

export function BundleStats({ bundle }: BundleStatsProps) {
  return (
    <VStack align="start" spacing="12px" width="100%">
      <Stats
        backgroundColor="transparent.white.05"
        stats={[
          {
            value: bundle.total_series,
            text: t("components.slideInMenu.bundleDetails.series"),
          },
          {
            value: bundle.total_items,
            text: t("components.slideInMenu.bundleDetails.releases"),
          },
          {
            value: bundle.total_pages,
            text: t("components.slideInMenu.bundleDetails.pages"),
          },
          {
            value: formatLargeNumber(bundle.total_pageviews),
            text: t("components.slideInMenu.bundleDetails.views"),
          },
        ]}
        expandable
      />
    </VStack>
  );
}
